// Update the search param in the URL replacing the current state with the new state which includes the param update.
export const replaceSearchParam = (searchParam: string, value: string) => {
  const url = new URL(window.location.href);
  url.searchParams.set(searchParam, value);
  window.history.replaceState({}, '', url);
};
